import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(
  () => ({
    root: {
      position: "relative",
      width: "100%",
      height: "100%",
      overflowX: "hidden",
      overflowY: "auto",
      scrollbarGutter: "stable both-edges",
    }
  })
);

export default function Scrollbar(props) {
  const { className } = props;
  const { classes } = useStyles();

  return (
    <div className={`${classes.root} ${className || ""}`} ref={props.scrollRef}>
      {props.children}
    </div>
  );
}